export const TIME_RELOAD_PHONE = 30;
export const TIME_RELOAD_EMAIL = 30;
export const TIME_RELOAD_FORGOT_PASSWORD = 30;
